<div>
  <h1>{{ translationService.getProductComponentInformationText() }}</h1>
  <div [formGroup]="componentForm" class="component-form-container">
    <ng-container formArrayName="components">
      @for (
        ungroupedComponentForm of getUngroupedComponents().controls;
        track ungroupedComponentForm;
        let componentIndex = $index
      ) {
        <div [formGroupName]="componentIndex" class="component-row">
          <div class="custom-form-row">
            <mat-form-field appearance="outline" class="input-lg">
              <input
                matInput
                #autoCompleteTextInput
                [matAutocomplete]="ungroupedAuto"
                [placeholder]="translationService.getSearchForAComponentText()"
                formControlName="name"
                (keyup)="onUngroupedComponentChange($event, componentIndex)"
              />
              <mat-autocomplete
                #ungroupedAuto="matAutocomplete"
                color="primary"
                class="grey-search-autocomplete"
                (optionSelected)="
                  onUngroupedSelectionChanged($event, componentIndex)
                "
              >
                @for (
                  component of filteredUngroupedOptions[componentIndex] || [];
                  track component
                ) {
                  <mat-option
                    [value]="component.id"
                    [disabled]="component.id === ''"
                  >
                    <span class="white-highlight-select component-name">{{
                      component.name
                    }}</span>
                  </mat-option>
                } @empty {
                  <mat-option value="null">
                    {{ translationService.getNoResultsText() }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field class="input-md invisible" appearance="outline">
              <mat-label>{{ translationService.getIdText() }}</mat-label>
              <input
                matInput
                name="id"
                formControlName="id"
                autocomplete="off"
              />
            </mat-form-field>
            <mat-form-field class="input-md" appearance="outline">
              <mat-label>
                {{ translationService.getMeasurementText() }}
              </mat-label>
              <input
                matInput
                [value]="getUngroupedComponentWeightAndUnit(componentIndex)"
                [disabled]="true"
              />
            </mat-form-field>
            <mat-form-field class="input-md" appearance="outline">
              <mat-label>
                {{ translationService.getQuantityText() }}
              </mat-label>
              <input
                matInput
                type="number"
                name="quantity"
                formControlName="quantity"
                autocomplete="off"
              />
            </mat-form-field>
          </div>
          <div class="custom-form-row">
            <mat-form-field class="input-md" appearance="outline">
              <mat-label>{{ translationService.getSupplierText() }}</mat-label>
              <input matInput formControlName="supplier" [disabled]="true" />
            </mat-form-field>
          </div>
          <div class="custom-form-row">
            <button
              mat-stroked-button
              extended
              color="primary"
              class="action-item remove-btn"
              (click)="removeUngroupedComponent(componentIndex)"
              type="button"
            >
              <mat-icon>delete</mat-icon>
              {{ translationService.getRemoveComponentText() }}
            </button>
          </div>
          <mat-divider></mat-divider>
        </div>
      }
    </ng-container>
    <ng-container formArrayName="componentGroups">
      @for (
        group of componentGroups.controls;
        track group;
        let groupIndex = $index
      ) {
        <div class="component-group-card" [formGroupName]="groupIndex">
          <div class="component-group-header">
            <div class="custom-form-row">
              <mat-form-field
                appearance="outline"
                class="input-lg component-group-name-field"
              >
                <mat-label>{{
                  translationService.getGroupNameText()
                }}</mat-label>
                <input
                  matInput
                  formControlName="name"
                  maxlength="36"
                  autocomplete="off"
                />
              </mat-form-field>
            </div>
          </div>
          <div formArrayName="components">
            @for (
              currentComponentForm of getComponentsForGroup(groupIndex)
                .controls;
              track currentComponentForm;
              let componentIndex = $index
            ) {
              <div [formGroupName]="componentIndex" class="component-row">
                <div class="custom-form-row">
                  <mat-form-field appearance="outline" class="input-lg">
                    <input
                      matInput
                      #autoCompleteTextInput
                      [matAutocomplete]="auto"
                      [placeholder]="
                        translationService.getSearchForAComponentText()
                      "
                      formControlName="name"
                      (keyup)="
                        onComponentChange($event, groupIndex, componentIndex)
                      "
                    />
                    <mat-autocomplete
                      #auto="matAutocomplete"
                      color="primary"
                      class="grey-search-autocomplete"
                      (optionSelected)="
                        onSelectionChanged($event, groupIndex, componentIndex)
                      "
                    >
                      @for (
                        component of filteredOptions[groupIndex][
                          componentIndex
                        ] || [];
                        track component
                      ) {
                        <mat-option
                          [value]="component.id"
                          [disabled]="component.id === ''"
                        >
                          <span class="white-highlight-select component-name">
                            {{ component.name }}
                          </span>
                        </mat-option>
                      } @empty {
                        <mat-option value="null">
                          {{ translationService.getNoResultsText() }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                  <mat-form-field
                    class="input-md invisible"
                    appearance="outline"
                  >
                    <mat-label>{{ translationService.getIdText() }}</mat-label>
                    <input
                      matInput
                      name="id"
                      formControlName="id"
                      autocomplete="off"
                    />
                  </mat-form-field>
                  <mat-form-field class="input-md" appearance="outline">
                    <mat-label>
                      {{ translationService.getMeasurementText() }}
                    </mat-label>
                    <input
                      matInput
                      [value]="
                        getComponentWeightAndUnit(groupIndex, componentIndex)
                      "
                      [disabled]="true"
                    />
                  </mat-form-field>
                  <mat-form-field class="input-md" appearance="outline">
                    <mat-label>
                      {{ translationService.getQuantityText() }}
                    </mat-label>
                    <input
                      matInput
                      type="number"
                      name="quantity"
                      formControlName="quantity"
                      autocomplete="off"
                    />
                  </mat-form-field>
                </div>
                <div class="custom-form-row">
                  <mat-form-field class="input-md" appearance="outline">
                    <mat-label>{{
                      translationService.getSupplierText()
                    }}</mat-label>
                    <input
                      matInput
                      formControlName="supplier"
                      [disabled]="true"
                    />
                  </mat-form-field>
                </div>
                <div class="custom-form-row">
                  <button
                    mat-stroked-button
                    extended
                    color="primary"
                    class="action-item remove-btn"
                    (click)="removeComponent(groupIndex, componentIndex)"
                    type="button"
                  >
                    <mat-icon>delete</mat-icon>
                    {{ translationService.getRemoveComponentText() }}
                  </button>
                </div>
                <mat-divider></mat-divider>
              </div>
            }
            @if (hasMinGroupSizeError(groupIndex)) {
              <div class="component-group-error">
                {{ translationService.getComponentGroupMinSizeErrorText() }}
              </div>
            }
            <div class="custom-form-row group-add-component-row">
              <button
                mat-raised-button
                extended
                color="primary"
                class="action-item"
                type="button"
                (click)="addComponentRow(groupIndex)"
              >
                <mat-icon>add</mat-icon>
                {{ translationService.getAddComponentText() }}
              </button>
              <button
                mat-stroked-button
                extended
                color="primary"
                class="action-item remove-group-btn"
                type="button"
                (click)="removeComponentGroup(groupIndex)"
              >
                <mat-icon>delete</mat-icon>
                {{ translationService.getRemoveGroupText() }}
              </button>
            </div>
          </div>
        </div>
      }
    </ng-container>
  </div>
  <div>
    <div class="actions margin-top-10 desktop-view">
      <button
        mat-raised-button
        extended
        color="primary"
        class="action-item"
        (click)="onSubmit()"
        [disabled]="!this.componentForm.valid"
      >
        <mat-icon>add</mat-icon>
        {{ translationService.getNextText() }}
      </button>
      <button
        mat-raised-button
        extended
        color="primary"
        class="action-item"
        (click)="goBack()"
      >
        <mat-icon>arrow_back</mat-icon>
        {{ translationService.getBackText() }}
      </button>
      <button
        mat-raised-button
        extended
        color="primary"
        class="action-item"
        type="button"
        (click)="addUngroupedComponentRow()"
      >
        <mat-icon>add</mat-icon>
        {{ translationService.getAddComponentText() }}
      </button>
      <button
        mat-raised-button
        extended
        color="primary"
        class="action-item"
        (click)="addComponentGroup()"
      >
        <mat-icon>add</mat-icon>
        {{ translationService.getAddComponentGroupText() }}
      </button>
      <button
        type="button"
        mat-stroked-button
        extended
        color="primary"
        class="action-item"
        (click)="onReset()"
      >
        <mat-icon>refresh</mat-icon>
        {{ translationService.getResetText() }}
      </button>
    </div>
    <div class="actions margin-top-10 mobile-view">
      <button
        mat-raised-button
        extended
        color="primary"
        class="action-item"
        (click)="onSubmit()"
        [disabled]="!this.componentForm.valid"
      >
        <mat-icon>add</mat-icon>
        {{ translationService.getNextText() }}
      </button>
      <button
        mat-raised-button
        extended
        color="primary"
        class="action-item"
        (click)="goBack()"
      >
        <mat-icon>arrow_back</mat-icon>
        {{ translationService.getBackText() }}
      </button>
      <button
        mat-raised-button
        extended
        color="primary"
        class="action-item"
        type="button"
        (click)="addUngroupedComponentRow()"
      >
        <mat-icon>add</mat-icon>
        {{ translationService.getAddComponentText() }}
      </button>
      <button
        mat-raised-button
        extended
        color="primary"
        class="action-item"
        (click)="addComponentGroup()"
      >
        <mat-icon>add</mat-icon>
        {{ translationService.getAddComponentGroupText() }}
      </button>
      <button
        type="button"
        mat-stroked-button
        extended
        color="primary"
        class="action-item"
        (click)="onReset()"
      >
        <mat-icon>refresh</mat-icon>
        {{ translationService.getResetText() }}
      </button>
    </div>
  </div>
</div>
